












import { Component, Prop, Vue } from "vue-property-decorator";
@Component({})
export default class FileItem extends Vue {
  @Prop()
  file: any;

  onDeleteClicked() {
    this.$emit("delete");
  }
}
